import React, { useEffect, useMemo, useState, Fragment } from 'react';
// import PropTypes from 'prop-types';
import { Container, Typography, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { RequirementsSearchForm } from './RequirementsSearchForm';
import { RequirementsInfo } from './RequirementsInfo';
import SearchSummary from './SearchSummary';
import { useLocation } from 'react-use';
import { parse } from 'query-string';
import { TravelRequirementsReqSchema } from './TravelRequirementsReqSchema';
import { countriesService } from '../../services';
import { useAsync } from 'react-use';
import { BackdropProgress, TimaticBranding } from '../../components';

TravelRequirements.propTypes = {};

function TravelRequirements(props) {
  const { t } = useTranslation();
  const [formData, setFormData] = useState(null);
  const isValidForm = useMemo(() => {
    return TravelRequirementsReqSchema.isValidSync(formData);
  }, [formData]);
  const [editMode, setEditMode] = useState(!isValidForm);
  const location = useLocation();

  const getCountries = async () => {
    const response = await countriesService.getCountries();
    return response;
  };

  const { loading, value: countriesResponse } = useAsync(getCountries);
  const { countries } = countriesResponse || {};

  const sanitizeSearchReq = (searchReq) => {
    if (searchReq && countries) {
      const {
        // arrivalDate = null,
        departureAirportCode = '',
        destinationCountryCode = '',
        documentType = '',
        nationality = '',
        // passportType = '',
        residentCountryCode = '',
        transitAirports,
      } = searchReq;
      let transitAirportsDetails = [];
      if (transitAirports) {
        let transitAirportCodes = transitAirports.split(',');
        transitAirportsDetails = countries.reduce((output, country) => {
          country.cities.map((city) => {
            city.airports
              .filter(
                (airport) => transitAirportCodes.indexOf(airport.code) > -1
              )
              .map((airport) => {
                output.push({
                  code: airport.code,
                  title: `${city.name}, ${country.code} (${airport.code} - ${airport.name})`,
                });
              });
          });
          return output;
        }, []);
      }

      setFormData({
        // arrivalDate,
        departureAirportCode,
        destinationCountryCode,
        documentType,
        nationality,
        // passportType,
        residentCountryCode,
        transitAirports: transitAirportsDetails,
      });
      setEditMode(false);
    }
  };

  useEffect(() => {
    const searchParams = parse(location.search);
    sanitizeSearchReq(searchParams);
  }, [countriesResponse]);

  if (!countries || !formData) {
    return null;
  }

  return (
    <Container maxWidth="md">
      <Box marginY={5}>
        <Box>
          <Typography variant="h5" color="primary">
            {t('pageHeading')}
          </Typography>
        </Box>
        <Box>
          {editMode || !isValidForm ? (
            <>
              <Typography gutterBottom>{t('introText1')}</Typography>
              <Typography gutterBottom>{t('introText5')}</Typography>
              <Typography gutterBottom>{t('introText2')}</Typography>
              <Typography gutterBottom>{t('introText3')}</Typography>
              <Box marginTop={2}>
                <RequirementsSearchForm
                  formData={formData}
                  countries={countries}
                  onSearch={(searchReq) => {
                    sanitizeSearchReq(searchReq);
                  }}
                />
              </Box>
            </>
          ) : (
            <>
              <Typography gutterBottom>{t('introText6')}</Typography>
              <Typography gutterBottom>{t('introText2')}</Typography>
              <Typography gutterBottom>{t('introText3')}</Typography>
              <Typography gutterBottom>{t('introText4')}</Typography>
              <Box marginY={2}>
                <SearchSummary
                  data={formData}
                  onClick={() => {
                    setEditMode(true);
                  }}
                />
              </Box>
              <RequirementsInfo formData={formData} />
            </>
          )}
        </Box>
        <Box marginY={3}>
          <TimaticBranding />
        </Box>
      </Box>
      <BackdropProgress show={loading} />
    </Container>
  );
}

export default TravelRequirements;
